import { createPortal } from 'react-dom';
import { OtherFormats } from '@/components/OtherFormats';
import { usePageData } from '@/contexts/pageContext';

const formatsPortal = document.querySelector(
  '.product__primary__details__row--formats',
);

export const useOtherFormats = () => {
  const { product } = usePageData();

  const products = product?.otherFormats;

  const elements = products?.length ? (
    <>
      <div
        className="product__primary__details__row__separator"
        role="presentation"
      >
        |
      </div>
      <OtherFormats products={products} />
    </>
  ) : null;

  return formatsPortal ? createPortal(elements, formatsPortal) : null;
};
